<template>
  <div
    class="hero-header bg-white"
    :class="getOuterClasses"
    :style="!innerCover ? getCover() : null"
  >
    <div v-if="heading || hasHeaderSlot()" class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-sm-flex justify-content-between align-items-center">
            <base-header class="hero-header-heading" :class="{ 'text-center': centered }" no-bottom-margin size="h1">
              <template v-if="hasHeaderSlot()">
                <slot name="header" />
              </template>
              <template v-else>
                {{ heading }}
              </template>
            </base-header>
            <div v-if="hasRightSlot">
              <slot name="right" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-header-inner" :class="getInnerClasses" :style="innerCover ? getCover() : null">
      <slot name="top" />
      <div class="container pb-4">
        <div class="row">
          <div class="col-12">
            <div class="mb-3 mt-4">
              <slot />
            </div>
          </div>
        </div>
      </div>
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroHeader',

  props: {
    centered: Boolean,
    cover: String,
    fullHeight: Boolean,
    heading: String,
    innerCover: Boolean,
    showOverlay: Boolean
  },

  computed: {
    getInnerClasses () {
      return {
        'hero-header-cover': this.hasCover() && this.innerCover,
        'hero-header-inner-full-height': this.fullHeight
      }
    },

    getOuterClasses () {
      return {
        'hero-header-cover': this.hasCover() && !this.innerCover,
        'hero-header-full-height': this.fullHeight,
        'hero-header-overlay': this.showOverlay
      }
    }
  },

  methods: {
    getCover () {
      if (this.hasCover()) {
        return `background-image: url(${this.cover})`
      }
    },

    hasCover () {
      return this.cover !== ''
    },

    hasHeaderSlot () {
      return this.$_.has(this.$slots, 'header')
    },

    hasRightSlot () {
      return this.$_.has(this.$slots, 'right')
    }
  }
}
</script>
